import React from 'react';
import { UrgencyBar } from './UrgencyBar';
import { HeroSection } from './HeroSection';
import { PainPointSection } from './PainPointSection';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { TomoSection } from './TomoSection';
import { BeforeAfterSection } from './BeforeAfterSection';
import { BonusSection } from './BonusSection';
import { PricingSection } from './PricingSection';
import { GuaranteeSection } from './GuaranteeSection';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { FooterSection } from './FooterSection';
import { SocialProofPopup } from './SocialProofPopup';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-159">
      <UrgencyBar data-id="element-160" />
      <HeroSection data-id="element-161" />
      <PainPointSection data-id="element-162" />
      <ProblemSection data-id="element-163" />
      <SolutionSection data-id="element-164" />
      <TomoSection data-id="element-165" />
      <BeforeAfterSection data-id="element-166" />
      <BonusSection data-id="element-167" />
      <PricingSection data-id="element-168" />
      <GuaranteeSection data-id="element-169" />
      <TestimonialsSection data-id="element-170" />
      <FAQSection data-id="element-171" />
      <FooterSection data-id="element-172" />
      <SocialProofPopup data-id="element-173" />
    </div>;
}